import ReportDelivery from '@/views/Report/Delivery.vue';
import ReportCSVFailedDelivery from '@/views/Report/CSV/FailedDeliveryCsvReport.vue';
import ReportCSVSuccessfulDelivery from '@/views/Report/CSV/SuccessfulDeliveriesCsvReport.vue';
import ReportCSVOutstandingBillDelivery from '@/views/Report/CSV/OutstandingBillCsvReport.vue';
import ReportCSVDriverIncome from '@/views/Report/CSV/DriverIncomeCsvReport.vue';
import ReportCSVDriverFuelConsumption from '@/views/Report/CSV/DriverFuelConsumptionReport.vue';
import ReportCSVVehicleMaintenanceCost from '@/views/Report/CSV/VehicleMaintenanceCostReport.vue';
import ReportCSVPackageIncome from '@/views/Report/CSV/PackageIncomeReport.vue';
import ReportCSVVehicleWork from '@/views/Report/CSV/VehicleWork.vue';
import ReportCSVVehicleWorkDayRatio from '@/views/Report/CSV/VehicleWorkDayRatioReport.vue';
import ReportCSVAreaIncomeReport from '@/views/Report/CSV/AreaIncomeReport.vue';
import ReportCSVUnderWeightedVehicleReport from '@/views/Report/CSV/UnderWeightedVehicleReport.vue';
import ReportCSVDeliveryDuration from '@/views/Report/CSV/DeliveryDuration.vue';
import ReportCSVAreaDeliveryCost from '@/views/Report/CSV/AreaDeliveryCost.vue';
import ReportCSVAreaGpReport from '@/views/Report/CSV/AreaGpReport.vue';
import ReportCSVAreaPercentTReport from '@/views/Report/CSV/AreaPercentTReport.vue';
import ReportCSVPackageCostReport from '@/views/Report/CSV/PackageCost.vue';
import ReportCSVRawDeliveries from '@/views/Report/CSV/RawDeliveriesCSV.vue';
import ReportCSVRawDeliveryNotes from '@/views/Report/CSV/RawDeliveryNoteCSV.vue';

function getComponentFile(name: string) {
  if (name === 'ReportDelivery') return ReportDelivery;
  if (name === 'ReportCSVFailedDelivery') return ReportCSVFailedDelivery;
  if (name === 'ReportCSVSuccessfulDelivery') return ReportCSVSuccessfulDelivery;
  if (name === 'ReportCSVOutstandingBillDelivery') return ReportCSVOutstandingBillDelivery;
  if (name === 'ReportCSVDriverIncome') return ReportCSVDriverIncome;
  if (name === 'ReportCSVDriverFuelConsumption') return ReportCSVDriverFuelConsumption;
  if (name === 'ReportCSVVehicleWork') return ReportCSVVehicleWork;
  if (name === 'ReportCSVVehicleMaintenanceCost') return ReportCSVVehicleMaintenanceCost;
  if (name === 'ReportCSVPackageIncome') return ReportCSVPackageIncome;
  if (name === 'ReportCSVVehicleWorkDayRatio') return ReportCSVVehicleWorkDayRatio;
  if (name === 'ReportCSVAreaIncomeReport') return ReportCSVAreaIncomeReport;
  if (name === 'ReportCSVUnderWeightedVehicleReport') return ReportCSVUnderWeightedVehicleReport;
  if (name === 'ReportCSVDeliveryDuration') return ReportCSVDeliveryDuration;
  if (name === 'ReportCSVAreaDeliveryCost') return ReportCSVAreaDeliveryCost;
  if (name === 'ReportCSVAreaGpReport') return ReportCSVAreaGpReport;
  if (name === 'ReportCSVAreaPercentTReport') return ReportCSVAreaPercentTReport;
  if (name === 'ReportCSVPackageCostReport') return ReportCSVPackageCostReport;
  if (name === 'ReportCSVRawDeliveries') return ReportCSVRawDeliveries;
  if (name === 'ReportCSVRawDeliveryNotes') return ReportCSVRawDeliveryNotes;

  return null;
}

export const moduleList = [
  // {
  //   path: 'delivery',
  //   name: 'ReportDelivery',
  //   display: 'ใบส่งสินค้า',
  // },
  // การบริการลูกค้า
  // {
  //   path: 'outstanding-bill-delivery',
  //   name: 'ReportCSVOutstandingBillDelivery',
  //   display: 'บิลค้างส่ง',
  // },
  // {
  //   path: 'success-delivery',
  //   name: 'ReportCSVSuccessfulDelivery',
  //   display: 'บิลส่งสำเร็จ',
  // },
  // {
  //   path: 'failed-delivery',
  //   name: 'ReportCSVFailedDelivery',
  //   display: 'บิลส่งไม่สำเร็จ',
  // },
  // {
  //   path: 'delivery-duration',
  //   name: 'ReportCSVDeliveryDuration',
  //   display: 'ระยะเวลาในการจัดส่ง (วัน)',
  // },
  // การจัดการรถบรรทุก และ พนง ขับรถ
  // {
  //   path: 'driver-fuel-consumption',
  //   name: 'ReportCSVDriverFuelConsumption',
  //   display: 'อัตราการเผาผลาญน้ำมัน (กม./ลิตร)',
  // },
  // {
  //   path: 'vehicle-work',
  //   name: 'ReportCSVVehicleWork',
  //   display: 'จำนวน เที่ยวรถวิ่ง (เที่ยว)',
  // },
  // FYI: Remove because TMS-607
  // {
  //   path: 'vehicle-maintenance-cost',
  //   name: 'ReportCSVVehicleMaintenanceCost',
  //   display: 'อัตราค่าซ่อมบำรุง (บาท/กม.)',
  // },
  // FYI: Remove because TMS-608
  // {
  //   path: 'vehicle-workday-ratio',
  //   name: 'ReportCSVVehicleWorkDayRatio',
  //   display: 'อัตรารถวิ่ง (%)',
  // },
  // {
  //   path: 'under-weight-vehicle',
  //   name: 'ReportCSVUnderWeightedVehicleReport',
  //   display: 'อัตราจัดรถไม่ผ่านขั้นต่ำ (%)',
  // },
  // {
  //   path: 'driver-income',
  //   name: 'ReportCSVDriverIncome',
  //   display: 'รายได้พนักงานขับรถ (บาท)',
  // },
  // รายได้ค่าจัดส่ง (Revenue)
  // {
  //   path: 'area-income-report',
  //   name: 'ReportCSVAreaIncomeReport',
  //   display: 'รายได้ค่าจัดส่ง ตามพื้นที่ (บาท)',
  // },
  // {
  //   path: 'package-income',
  //   name: 'ReportCSVPackageIncome',
  //   display: 'รายได้ค่าจัดส่งต่อหีบห่อ (บาท/หีบห่อ)',
  // },
  // ต้นทุนค่าจัดส่ง (Cost)
  // {
  //   path: 'area-delivery-cost',
  //   name: 'ReportCSVAreaDeliveryCost',
  //   display: 'ต้นทุนค่าจัดส่ง ตามพื้นที่จัดส่ง (บาท)',
  // },
  // {
  //   path: 'package-delivery-cost',
  //   name: 'ReportCSVPackageCostReport',
  //   display: 'ต้นทุนค่าจัดส่งต่อหีบห่อ (บาท/หีบห่อ)',
  // },
  // FYI: Remove because TMS-610
  // {
  //   path: 'percent-t',
  //   name: 'ReportCSVAreaPercentTReport',
  //   display: '%T ต้นทุนค่าจัดส่ง/มูลค่าสินค้า (%T)',
  // },
  // กำไรค่าจัดส่ง (Profit)
  // {
  //   path: 'area-gp',
  //   name: 'ReportCSVAreaGpReport',
  //   display: '%กำไรขั้นต้น (%GP)',
  // },
  // Raw Deliveries Data
  {
    path: 'raw-deliveries',
    name: 'ReportCSVRawDeliveries',
    display: 'Raw Data for DO',
  },
  // Raw Deliveries Data
  {
    path: 'raw-delivery-notes',
    name: 'ReportCSVRawDeliveryNotes',
    display: 'Raw Data for DN',
  },
];

export default moduleList.map((module: any) => ({
  path: module.path,
  name: module.name,
  component: getComponentFile(module.name),
}));
